///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const BellIcon = ({
  height,
  title = messages.bell.defaultMessage,
  width,
  fill = "#FFFFFF",
  secondaryColor = "#0088D1",
  ...props
}) => {
  return (
    <svg
      aria-labelledby="bell-icon"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      {...props}
    >
      <title id="bell-icon">{title}</title>
      <defs>
        <path
          d="M12 22l2-2h-4l2 2zm6-6v-5c0-3-2-6-4-6V4a1 1 0 10-3 0v1c-3 0-5 3-5 6v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2 2-4 4-4s4 2 4 4v6z"
          id="bell-icon-path"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle fill={secondaryColor} cx="18" cy="18" r="18" />
        <g transform="translate(6 6)">
          <path d="M0 0h24v24H0z" />
          <mask id="bell-icon-mask" fill={fill}>
            <use xlinkHref="#bell-icon-path" />
          </mask>
          <use fill="#000" xlinkHref="#bell-icon-path" />
          <g mask="url(#bell-icon-mask)" fill={fill}>
            <path d="M0 0h24v24H0z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BellIcon;
